// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ziM7","input":"styles_input__ui-QH"};